import endpoints from '../../constants/endpoints';
import { getHttpInstance } from '../../services/defaultHttpService';
import * as types from './constants';
import { isDev, replaceTokensInUrl } from '../../utils';
import {
  GENERIC_USER_ID,
  TIMEOUT_DOUBLED,
  TIMEOUT_EXTENDED
} from '../../constants/commonConstants';
import { ERROR_DOMAIN, ERROR_PATH } from '../../constants/errorConstants';
import { createGuestIdentity } from '@app/store/common/actions';
import { setError, clearError } from '../exception/actions';
import { normalizeError } from '../exception/utils';
import {
  getServiceResponseTime,
  gaTimeTracker
} from '@app/components/common/analytics/analyticsUtils';
import { PRICE_AND_AVAILABILITY_API } from '@app/constants/analyticsConstants';

export const getProductSchematics =
  (configuration, serialNumber, usePartNumber = true) =>
  async (dispatch, getState) => {
    const timeout = isDev() ? TIMEOUT_EXTENDED : TIMEOUT_DOUBLED;
    const http = getHttpInstance(timeout);

    const storeId = getState().common.storeId;
    const langId = getState().common.langId;
    const partUniqueId = usePartNumber
      ? getState().products.current
      : configuration;
    const partNumber = usePartNumber
      ? getState().products.byId[partUniqueId].partNumber
      : configuration;
    const equipmentSerialNumber = usePartNumber
      ? getState().myEquipment.equipments.selectedEquipment.serialNumber
      : serialNumber;

    const url = replaceTokensInUrl(
      endpoints.PRODUCT_SCHEMATICS,
      storeId,
      partUniqueId,
      partNumber,
      equipmentSerialNumber,
      langId
    );

    dispatch({ type: types.SCHEMATICS_GET_BEGIN });
    dispatch(clearError(ERROR_DOMAIN.PDP, ERROR_PATH.SCHEMATICS));
    try {
      const { data } = await http.get(url);

      const currentEquipmentPreviousSchematics =
        getState().schematics?.[equipmentSerialNumber] ?? {};
      const payload = {
        [equipmentSerialNumber]: {
          ...currentEquipmentPreviousSchematics,
          [partUniqueId]: { ...data }
        }
      };
      dispatch({ type: types.SCHEMATICS_GET_SUCCESS, payload });
    } catch (error) {
      dispatch({ type: types.SCHEMATICS_GET_FAIL, payload: error });
      // throw error;
      dispatch(
        setError(ERROR_DOMAIN.PDP, ERROR_PATH.SCHEMATICS, {
          ...normalizeError(
            error,
            {
              severity: 'error',
              message: 'UNKNOWN_ERROR_MESSAGE',
              title: 'UNKNOWN_ERROR_TITLE'
            },
            true
          )
        })
      );
    }
  };

// This actions is redundant to the price and availability action for product,
// removing that redundance will be taken care of in a new user story
export const getSchematicsPriceAndAvailability =
  (partsList = [], priceCallError = {}) =>
  async (dispatch, getState) => {
    const http = getHttpInstance(TIMEOUT_EXTENDED);
    const { isCatCorp, langId, storeId, userId } = getState().common;
    const url = replaceTokensInUrl(
      endpoints.PRICE_AVAILABILITY_URL,
      storeId,
      langId
    );
    dispatch({ type: types.SCHEMATICS_GET_PRICE_BEGIN });
    dispatch(clearError(ERROR_DOMAIN.PDP, ERROR_PATH.SCHEMATICS));
    const postParams = { partsList };
    try {
      if (userId === GENERIC_USER_ID && !isCatCorp) {
        await dispatch(createGuestIdentity());
      }
      const response = await http.post(url, postParams);
      const { data: payload, config } = response;
      const serviceResponseTime = getServiceResponseTime(config);

      gaTimeTracker(serviceResponseTime, PRICE_AND_AVAILABILITY_API);

      dispatch({ type: types.SCHEMATICS_GET_PRICE_SUCCESS, payload });
    } catch (error) {
      dispatch({ type: types.SCHEMATICS_GET_PRICE_FAIL, payload: error });
      dispatch(
        setError(ERROR_DOMAIN.PDP, ERROR_PATH.SCHEMATICS, {
          ...normalizeError(error, priceCallError, true)
        })
      );
    }
  };
